import type { ComponentProps } from "react"

export default function PlotFilled(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "hsl(var(--foreground))", ...svgProps } = props

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M11.5619 2.43662C9.63128 0.0362339 5.95452 -0.596576 4.30218 0.564554C2.89202 1.55478 2.55706 3.01572 2.23284 4.42783C2.05511 5.2042 1.87151 6.00693 1.50432 6.70517C1.33635 7.02548 1.10295 7.31064 0.877371 7.58701C0.187921 8.43467 -0.595289 9.3956 0.682061 11.171C1.63714 12.4991 2.60394 12.3858 3.53948 12.2784C4.05315 12.2188 4.58733 12.1554 5.25237 12.2735C5.82171 12.3751 6.54143 12.6612 7.30315 12.964C8.47405 13.4288 9.74163 13.9327 10.8657 13.9327C11.5737 13.9327 12.2241 13.7335 12.7592 13.1993C15.1176 10.8448 13.6586 5.04698 11.5619 2.43662ZM3.20843 4.65147C3.51507 3.31065 3.7807 2.15245 4.8764 1.38292C5.5119 0.936574 6.74658 0.885484 8.00256 1.26262L2.63464 6.63053C2.89941 5.97971 3.05804 5.30735 3.20843 4.65147ZM2.09057 11.1746C1.89587 11.061 1.70532 10.8805 1.49456 10.587C1.21978 10.2049 1.08398 9.90622 1.03551 9.64371L9.01122 1.668C9.55181 1.94284 10.0564 2.30936 10.4952 2.76999L2.09057 11.1746ZM5.4262 11.2892C5.08831 11.2286 4.77581 11.2081 4.48772 11.2081C4.08635 11.2081 3.73284 11.2491 3.42327 11.2853C3.41161 11.2866 3.40191 11.2875 3.39043 11.2888L11.1332 3.546C11.4599 4.03684 11.7631 4.61424 12.0251 5.24003L5.87194 11.3932C5.71996 11.3523 5.56988 11.3147 5.4262 11.2892ZM7.67229 12.0343C7.42015 11.9341 7.17455 11.8382 6.93267 11.7466L12.4025 6.27671C12.6239 6.96616 12.7903 7.68027 12.8845 8.38065L8.79961 12.4656C8.4215 12.3303 8.04125 12.181 7.67229 12.0343ZM12.0522 12.4923C11.5464 12.9969 10.7598 12.9955 9.88757 12.7917L12.969 9.71025C12.9529 10.8533 12.6849 11.8606 12.0522 12.4923Z"
        fill={fill}
      />
    </svg>
  )
}
